import { useState, useMutations } from 'vuex-composition-helpers';
import { computed, unref } from 'vue';
import getStore from '@fr/vue/services/getStore/getStore';
import registerModule from '@fr/vue/services/registerModule';
import PrepaymentFilterModel, {
    NAMESPACE,
    IFilterPrepaymentState,
    IFilterPrepaymentMutations,
} from '../model/PrepaymentFilterModel';

export default function () {
    registerModule.register(getStore(), PrepaymentFilterModel, NAMESPACE);
    const {
        prepaymentsFilter,
    } = useState<IFilterPrepaymentState>(NAMESPACE, ['prepaymentsFilter']);
    const {
        setPrepaymentFilter,
    } = useMutations<IFilterPrepaymentMutations>(NAMESPACE, ['setPrepaymentFilter']);

    const selectedPrepayments = computed({
        get: () => unref(prepaymentsFilter),
        set: (value: IFilterPrepaymentState['prepaymentsFilter']) => {
            setPrepaymentFilter(value);
        },
    });

    return {
        setPrepaymentFilter,
        selectedPrepayments,
    };
}
